var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoatMiddle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.4,
    height: 27.8,
    viewBox: "0 0 63.4 27.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-1 {\n        opacity: 0.25;\n      }\n\n      .cls-2 {\n        fill: #d8d8d8;\n      }\n\n      .cls-4 {\n        fill: #193f49;\n      }\n\n      .cls-5 {\n        fill: #fdb;\n      }\n\n      .cls-6 {\n        fill: #069cc1;\n      }\n\n      .cls-7 {\n        fill: #00c9ff;\n      }\n\n      .cls-8 {\n        fill: #ffd8ae;\n      }\n\n      .cls-9 {\n        fill: #343a3f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.8,18.2a3.8,3.8,0,0,1-3.7-3.7,3.7,3.7,0,0,1,3.7-3.6,3.6,3.6,0,0,1,3.6,3.6A3.7,3.7,0,0,1,56.8,18.2Zm0-5.9A2.3,2.3,0,1,0,59,14.5,2.2,2.2,0,0,0,56.8,12.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.8,21.1a6.6,6.6,0,1,1,0-13.2,6.6,6.6,0,1,1,0,13.2Zm0-11.8a5.2,5.2,0,0,0-5.3,5.2,5.3,5.3,0,0,0,5.3,5.3A5.2,5.2,0,0,0,62,14.5,5.2,5.2,0,0,0,56.8,9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.6,18.2A3.7,3.7,0,0,1,3,14.5a3.6,3.6,0,1,1,7.2,0A3.7,3.7,0,0,1,6.6,18.2Zm0-5.9a2.3,2.3,0,1,0,0,4.5,2.3,2.3,0,1,0,0-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.6,21.1a6.6,6.6,0,1,1,6.6-6.6A6.6,6.6,0,0,1,6.6,21.1Zm0-11.8a5.2,5.2,0,0,0-5.3,5.2,5.3,5.3,0,0,0,5.3,5.3,5.3,5.3,0,0,0,5.3-5.3A5.2,5.2,0,0,0,6.6,9.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 34,
    y: 9.1,
    width: 17.7,
    height: 1.33,
    rx: 0.7,
    transform: "translate(19.5 -27.4) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 34,
    y: 20.7,
    width: 17.6,
    height: 1.33,
    rx: 0.7,
    transform: "translate(-2.6 36.5) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.8,
    y: 9.1,
    width: 17.7,
    height: 1.33,
    rx: 0.7,
    transform: "translate(42.2 2.1) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.9,
    y: 20.7,
    width: 17.6,
    height: 1.33,
    rx: 0.7,
    transform: "translate(20.2 51.1) rotate(-135)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.7,
    width: 12.1,
    height: 27.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 26.4,
    y: 1.3,
    width: 10.8,
    height: 25.72,
    rx: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31.2,10.4h0L31,17.1l-.3,6.1a1.6,1.6,0,0,1-1.5,1.6,1.6,1.6,0,0,1-1.6-1.6l-.2-6.1-.3-6.6c0-1.6.9-2.9,2.1-2.9S31.2,8.9,31.2,10.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M36.3,10.4h0l-.2,6.6-.3,6.1a1.6,1.6,0,0,1-1.5,1.6,1.6,1.6,0,0,1-1.6-1.6l-.2-6.1-.3-6.6c0-1.6.9-2.9,2.1-2.9S36.3,8.9,36.3,10.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M31.2,10.4h0L31,17.1H27.4l-.3-6.6c0-1.6.9-2.9,2.1-2.9S31.2,8.9,31.2,10.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M36.3,10.4h0l-.2,6.6H32.5l-.3-6.6c0-1.6.9-2.9,2.1-2.9S36.3,8.9,36.3,10.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 34.2,
    y: 15.3,
    width: 22.7,
    height: 1.33,
    rx: 0.7,
    transform: "translate(-1.7 5.9) rotate(-7.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.6,
    y: 15.3,
    width: 22.7,
    height: 1.33,
    rx: 0.7,
    transform: "translate(33.7 34.1) rotate(-172.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M41.5,11a1.3,1.3,0,0,0-.1-.6L39.1,5.5l-.3-.4a3.3,3.3,0,0,0-2.7-1.5H27.3A3.3,3.3,0,0,0,24.7,5a1,1,0,0,0-.4.5L22,10.4a1.3,1.3,0,0,0-.1.6,1.7,1.7,0,0,0,.1.7l2.4,5.2a1.2,1.2,0,0,0,1.7.6,1.2,1.2,0,0,0,.7-1.7l-2.2-4.6.6-1.3a3.2,3.2,0,0,0,2.1.8h8.8a3.2,3.2,0,0,0,2.1-.8l.6,1.3-2.2,4.6a1.3,1.3,0,0,0,.6,1.7,1.2,1.2,0,0,0,1.7-.6l2.5-5.2A1.7,1.7,0,0,0,41.5,11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 27.1,
    y: 3.6,
    width: 9.3,
    height: 7.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M35.1,8.2a3.4,3.4,0,0,1-.1,1,3.4,3.4,0,0,1-3.3,2.4,3.5,3.5,0,0,1-3.3-2.4,3.4,3.4,0,0,1-.1-1,3.4,3.4,0,1,1,6.8,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M35.1,8.2a3.4,3.4,0,0,1-.1,1,6,6,0,0,1-3.3.9,6.3,6.3,0,0,1-3.3-.9,3.4,3.4,0,0,1-.1-1,3.4,3.4,0,1,1,6.8,0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoatMiddle);
export default __webpack_public_path__ + "static/media/boat-middle.ecc014ee3e8669e77fde19ccf0a8f915.svg";
export { ForwardRef as ReactComponent };